export const MENU_CATEGORIES = [
  {
    id: "beverages",
    label: "Beverages",
    tagline: "Slow-brewed coffee, spiced chai, zero-proof mocktails and indulgent shakes — everything but alcohol.",
    groups: [
      {
        title: "Hot Cups",
        items: [
          { name: "Espresso Shot" },
          { name: "Americano" },
          { name: "Cappuccino" },
          { name: "Cafe Latte" },
          { name: "Café Mocha" },
          { name: "Cinnamon Cappuccino" },
          { name: "Irish Coffee" },
        ],
      },
      {
        title: "Cold Cups",
        items: [
          { name: "Affogato" },
          { name: "Ice Americano" },
          { name: "Ice Cinnamon Soy" },
          { name: "Ice Vietnamese" },
          { name: "Vanilla Cold Coffee" },
          { name: "Choco Frappe" },
        ],
      },
      {
        title: "Chai",
        items: [
          { name: "Assam Tea" },
          { name: "Lemon Tea" },
          { name: "Masala Tea" },
          { name: "Green Tea" },
          { name: "Ice Lemon Tea" },
        ],
      },
      {
        title: "Mocktails",
        items: [
          { name: "Virgin Mojito / Mint Cooler" },
          { name: "Masala Lemonade" },
          { name: "Blue Lagoon" },
          { name: "Strawberry Cooler" },
        ],
      },
      {
        title: "Shakes",
        items: [
          { name: "Vanilla" },
          { name: "Oreo" },
          { name: "Chocolate" },
          { name: "Strawberry" },
          { name: "Fresh Mango" },
          { name: "Nutella" },
          { name: "Biscoff" },
          { name: "Mocha Brownie" },
          { name: "Banana Shake" },
        ],
      },
    ],
  },
  {
    id: "breakfast-snacks",
    label: "Breakfast & Snacks",
    tagline: "Sunrise comforts, kebabs and crowd-pleasing bites — fried, baked and made with amore.",
    groups: [
      {
        title: "Breakfast",
        items: [
          { name: "Bun Maska" },
          { name: "Poha" },
          { name: "Upma" },
          { name: "Besan Chilla" },
          { name: "Puri Bhaji" },
          { name: "Sauteed Vegetable" },
          { name: "Pakoda Mix" },
          { name: "Scrambled Egg", nv: true },
          { name: "Boiled Egg", nv: true },
          { name: "Sauteed Vegetable with Sausage / Chicken", nv: true },
        ],
      },
      {
        title: "Kebabs",
        items: [
          { name: "Dahi ke Sholey" },
          { name: "Hara Bhara Kebab" },
          { name: "Falafel Meze Platter" },
        ],
      },
      {
        title: "Snacks",
        items: [
          { name: "Cheesy Garlic Bread" },
          { name: "Bruschetta" },
          { name: "Spiced Potato Croquettes (2 pc)" },
          { name: "Corn Fritters (4 pc)" },
          { name: "Cheesy Sticks (4 pc)" },
          { name: "Veg Cutlet (2 pc)" },
          { name: "Paneer Cutlet (2 pc)" },
          { name: "Veg Cigar" },
          { name: "Spinach Cigar" },
          { name: "Tacos (2 pc)" },
          { name: "Quesadilla" },
          { name: "Mushroom Tart" },
          { name: "Baked Nachos" },
          { name: "Chaat Style Fries" },
          { name: "Cheesy Fries" },
          { name: "Peri Peri Fries" },
          { name: "Salted Fries" },
          { name: "Crispy Paneer" },
        ],
      },
      {
        title: "Non-Veg Snacks",
        items: [
          { name: "Chicken Nuggets", nv: true },
          { name: "White Velvet Chicken Wings", nv: true },
          { name: "Barbeque Chicken Wings", nv: true },
        ],
      },
    ],
  },
  {
    id: "soups-chinese",
    label: "Soups & Chinese",
    tagline: "Slow-simmered broths and wok-tossed favourites, from Minestrone to Manchow.",
    groups: [
      {
        title: "Soups",
        items: [
          { name: "Tomato Soup" },
          { name: "Minestrone Soup" },
          { name: "Cream of Mushroom" },
          { name: "Tom Yum Thai Soup" },
          { name: "Korean Wonton Soup" },
          { name: "Manchow Soup" },
          { name: "Cream of Chicken Soup", nv: true },
        ],
      },
      {
        title: "Chinese",
        items: [
          { name: "Hakka Noodles" },
          { name: "Chilli Garlic Noodles" },
          { name: "Chilli Potato" },
          { name: "Honey Chilli Potato" },
          { name: "Chilli Paneer" },
          { name: "Veg Momo" },
          { name: "Paneer Momo" },
          { name: "Crispy Corn" },
          { name: "Chilli Chicken", nv: true },
        ],
      },
    ],
  },
  {
    id: "pasta-pizza",
    label: "Pasta & Pizza",
    tagline: "Our Italian soul — silky sauces, hand-stretched bases and a wood-fired heart.",
    groups: [
      {
        title: "Pasta",
        note: "Choice of pasta: Spaghetti / Fettuccine · Add chicken to any pasta",
        items: [
          { name: "Alfredo White" },
          { name: "Arrabbiata" },
          { name: "Aglio e Olio" },
          { name: "Ala Fungi" },
          { name: "Ravioli Spinach Corn Arrabbiata" },
          { name: "Ravioli Spinach Corn Alfredo" },
          { name: "Pesto Basil" },
          { name: "Creamy Fusion" },
          { name: "Lasagna" },
        ],
      },
      {
        title: "Pizza",
        items: [
          { name: "Margheritta" },
          { name: "Turkish Pizza" },
          { name: "Flat Bread" },
          { name: "Paneer Tikka Pizza" },
          { name: "Tangy Spicy Pizza" },
          { name: "Nirvana Pizza" },
          { name: "Spiced Chicken Pizza", nv: true },
          { name: "Barbeque Pizza", nv: true },
        ],
      },
    ],
  },
  {
    id: "sandwiches-burgers-wraps",
    label: "Sandwiches, Burgers & Wraps",
    tagline: "Stacked, toasted and rolled — handheld happiness for every craving.",
    groups: [
      {
        title: "Sandwiches",
        items: [
          { name: "Desi Vibes" },
          { name: "Club" },
          { name: "Curd" },
          { name: "Spinach Corn" },
          { name: "Pesto Paneer" },
          { name: "Garden Melt" },
          { name: "Classic Veggie Toastie" },
          { name: "Guacamole (Avocado)" },
          { name: "Mushroom" },
          { name: "Panini" },
          { name: "Honey Mustard Chicken", nv: true },
          { name: "Creamy Chicken Grilled", nv: true },
          { name: "Chicken Club", nv: true },
          { name: "Croissant Egg Pesto", nv: true },
        ],
      },
      {
        title: "Burgers",
        items: [
          { name: "Potato Burger" },
          { name: "Paneer Fusion Burger" },
          { name: "Mushroom Slider Burger" },
          { name: "Bombay Burger" },
          { name: "Crispy Chicken Burger", nv: true },
          { name: "Fried Chicken Burger", nv: true },
        ],
      },
      {
        title: "Wraps",
        items: [
          { name: "Veg Kathi" },
          { name: "Paneer Kathi" },
          { name: "Paneer Tikka" },
          { name: "Crispy Paneer" },
          { name: "Veg Keema" },
          { name: "Pesto Veggie" },
          { name: "Falafel Hummus" },
          { name: "Mexican Burrito" },
          { name: "Egg Wrap", nv: true },
          { name: "Chicken Kathi Roll", nv: true },
          { name: "Peri Peri Chicken", nv: true },
        ],
      },
    ],
  },
  {
    id: "salads-mains",
    label: "Salads & Mains",
    tagline: "Our Indian heart — overnight dals, copper-handi curries, biryanis and fresh tawa breads.",
    groups: [
      {
        title: "Salads",
        items: [
          { name: "Caesar Salad" },
          { name: "Macaroni Peanut Salad" },
          { name: "Greek Salad" },
          { name: "Russian Salad" },
          { name: "Mix Chana Salad" },
          { name: "Quinoa Salad" },
        ],
      },
      {
        title: "Mains — Curry",
        note: "Make a combo of any curry with rice / 2 roti",
        items: [
          { name: "Dal Tadka / Mix Dal" },
          { name: "Rajma" },
          { name: "Chole" },
          { name: "Dal Palak" },
          { name: "Dal Makhani" },
          { name: "Matar Paneer" },
          { name: "Paneer Makhani" },
          { name: "Palak Paneer" },
          { name: "Kadahi Paneer" },
          { name: "Shahi Paneer" },
          { name: "Paneer Lababdar" },
          { name: "Paneer Do Pyaza" },
          { name: "Matar Mushroom" },
          { name: "Mushroom Masala" },
          { name: "Kadahi Mushroom" },
          { name: "Mix Veg" },
          { name: "Soya Chaap Masala" },
          { name: "Kashmiri Dum Aloo" },
          { name: "Butter Chicken", nv: true },
          { name: "Chicken Curry", nv: true },
          { name: "Kadahi Chicken", nv: true },
          { name: "Chicken Rara", nv: true },
        ],
      },
      {
        title: "Thai Curry",
        items: [
          { name: "Thai Curry with Steamed Rice" },
          { name: "Thai Curry with Steamed Rice & Chicken", nv: true },
        ],
      },
      {
        title: "Rice",
        items: [
          { name: "Steamed Rice" },
          { name: "Jeera Rice" },
          { name: "Matar Pulao" },
          { name: "Veg Pulao" },
          { name: "Veg Biryani" },
          { name: "Egg Biryani", nv: true },
        ],
      },
      {
        title: "Breads",
        items: [
          { name: "Tawa Roti" },
          { name: "Plain Paratha" },
          { name: "Ajwain Paratha" },
          { name: "Lachha Paratha (Pudina / Methi / Dhaniya / Mirch)" },
          { name: "Mix Paratha" },
          { name: "Aloo Pyaz Paratha" },
        ],
      },
      {
        title: "Thali",
        items: [
          { name: "Forco Thali — Dal Makhani, Paneer, Mix Veg, Rice, 2 Chapati, Salad, Raita, Dessert" },
        ],
      },
      {
        title: "Signature Dishes",
        items: [
          { name: "Veg Bird Nest (2 pc)" },
          { name: "Veg Cottage Cheese Steak" },
          { name: "Grilled Chicken Steak", nv: true },
        ],
      },
    ],
  },
  {
    id: "bakery",
    label: "Bakery",
    tagline: "From our in-house ovens — tea cakes, pastries, celebration cakes and hand-crafted cookies.",
    groups: [
      {
        title: "Tea Cakes",
        items: [
          { name: "Dates & Almond Slice" },
          { name: "Dates & Almond Loaf" },
          { name: "Pista Mawa Slice" },
          { name: "Pista Mawa Loaf" },
          { name: "Marble Tea Cake Slice" },
          { name: "Marble Tea Cake Loaf" },
        ],
      },
      {
        title: "Pastry",
        items: [
          { name: "Choco Almond Pastry" },
          { name: "Double Chocolate Pastry" },
          { name: "Mango Pastry" },
          { name: "Rainbow Pastry" },
          { name: "Fruity Tub" },
          { name: "Chocolate Mousse" },
          { name: "Doughnut" },
        ],
      },
      {
        title: "Cakes",
        items: [
          { name: "Chocolate Truffle Cake" },
          { name: "Belgian Cake" },
          { name: "London Cake" },
          { name: "Fruit Cake" },
          { name: "Customized Cake (as per design)" },
          { name: "Choco Chip Muffins" },
          { name: "Cup Cake" },
        ],
      },
      {
        title: "Chocolate",
        items: [
          { name: "Almond Chocolate" },
          { name: "Choco Cacao" },
        ],
      },
      {
        title: "Breads",
        note: "Prior order for 2 hrs",
        items: [
          { name: "Sandwich Bread" },
          { name: "Multigrain Bread" },
          { name: "Honey Oats" },
          { name: "Baguette" },
          { name: "Buns (Pack of 4)" },
          { name: "Pao (Pack of 6)" },
        ],
      },
      {
        title: "Hand-Crafted Cookies",
        items: [
          { name: "Cookie Single" },
          { name: "Honey Ragi Oats" },
          { name: "Karachi" },
          { name: "Almond Stick" },
          { name: "Double Chocolate" },
          { name: "Honey Muesli" },
        ],
      },
    ],
  },
];
